/** Сравнение без регистра и различия «ё»/«е». */
export const normalizeText = (value: string) => value.toLowerCase().replaceAll('ё', 'е').trim();

/** Все слова запроса встречаются в тексте (в любом порядке, как подстроки). Пустой запрос подходит всему. */
export function matchesWords(haystack: readonly (string | undefined)[], query: string): boolean {
  const words = normalizeText(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const text = normalizeText(haystack.filter(Boolean).join(' '));
  return words.every((word) => text.includes(word));
}
